var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.recognition)?_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.start}},[_c('b-icon-mic')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }